import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)


const routes = [{
		path: '/',
		name: 'login',
		meta: {
			title: '華亞證券開戶系統',
		},
		component: () =>
			import('../views/login/login.vue')
	},
	{
		path: '/login1',
		name: 'login',
		meta: {
			title: '華亞證券開戶系統',
		},
		component: () =>
			import('../views/login/login1.vue')
	},
	{
		path: '/accountOpening',
		name: 'accountOpening',
		meta: {
			title: '證券交易帳戶協議書',
		},
		component: () =>
			import('../views/accountOpening/account.vue')
	},
	{
		path: '/filePage',
		name: 'filePage',
		meta: {
			title: '華亞證券開戶系統',
		},
		component: () =>
			import('../views/filePage/filePage.vue')
	},
	{
		path: '/beCareful',
		name: 'beCareful',
		meta: {
			title: '華亞證券開戶系統',
		},
		component: () =>
			import('../views/beCareful/beCareful.vue')
	},
	{
		path: '/main',
		name: 'main',
		meta: {
			title: '華亞證券開戶系統',
		},
		component: () =>
			import('../views/main/main.vue'),
		children: [{
				path: '/main/checkPdf',
				name: 'checkPdf',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
				},
				component: () =>
					import('../views/checkPdf/checkPdf.vue')
			},
			
			{
				path: '/main/accountOpeningType',
				name: 'accountOpeningType',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 1,
				},
				component: () =>
					import('../views/1_khlx/1_khlx.vue')
			},
			{
				path: '/main/essentialInformationMain',
				name: 'essentialInformationMain',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 2,
				},
				component: () =>
					import('../views/2_jbxxMain/2_jbxxMain.vue')
			},
			{
				path: '/main/employed',
				name: 'employed',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 3,
				},
				component: () =>
					import('../views/3_jbxxSg/3_jbxxSg.vue')
			},
			{
				path: '/main/finance',
				name: 'finance',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 4,
				},
				component: () =>
					import('../views/4_jbxxCw/4_jbxxCw.vue')
			},
			{
				path: '/main/customerStatement',
				name: 'customerStatement',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 5,
				},
				component: () =>
					import('../views/5_khsm/5_khsm.vue')
			},
			{
				path: '/main/riskManagement',
				name: 'riskManagement',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 6,
				},
				component: () =>
					import('../views/6_fxpg/6_fxpg.vue')
			},
			{
				path: '/main/uploadFile',
				name: 'uploadFile',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 7,
				},
				component: () =>
					import('../views/7_scwj/7_scwj.vue')
			},
			{
				path: '/main/timeOfAppointment',
				name: 'timeOfAppointment',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
				},
				component: () =>
					import('../views/8_yykh/8_yykh.vue')
			},
			{
				path: '/main/finish',
				name: 'finish',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 7,
				},
				component: () =>
					import('../views/9_yywc/9_yywc.vue')
			},
			{
				path: '/main/finish_cg',
				name: 'finish_cg',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
				},
				component: () =>
					import('../views/13_yykhcg/9_yywc.vue')
			},
			{
				path: '/main/bankopen',
				name: 'bankopen',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 7,
				},
				component: () =>
					import('../views/10_bank/10_bank.vue')
			},
			{
				path: '/main/bankyhkh',
				name: 'bankyhkh',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 7,
				},
				component: () =>
					import('../views/11_yhkh/11_yhkh.vue')
			},
			{
				path: '/main/bankwc',
				name: 'bankwc',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
					keyIndex: 7,
				},
				component: () =>
					import('../views/12_wchk/12_wchk.vue')
			},
			{
				path: '/main/Officialwebsite',
				name: 'Officialwebsite',
				title: '華亞證券開戶系統',
				meta: {
					title: '華亞證券開戶系統',
				},
				component: () =>
					import('../views/8_yykh/Officialwebsite.vue')
			},
		]
	},
]
const router = new VueRouter({
	mode: 'history',
	base:store.state.endurl,
	// 部署正式
	// base: '/webkh', //测试
	// base: '/webnewcs',  //正式临时
	base: '/accopen',//正式
	// base:'/qmis',
	routes,
	scrollBehavior(to, from, savedPosition) {
		// console.log(to, from, savedPosition);
		return {
			x: 0,
			y: 0
		}
	}
})
// console.log(store,this.$route)
router.beforeEach((to, from, next) => {
	//跳转 手机app
	if (store.state.onlinestate == 'phone') {
		let language = '';
		if (to.query.lang == 'eng') {
			language = 'https://hk.iqmis.com/app/apk/appdownload/khappeng.html';
		} else if (to.query.lang) {
			language = 'https://hk.iqmis.com/app/apk/appdownload/khappcn.html';
		}
		if (location.pathname == store.state.urlapi || location.pathname == store.state.endurl) {
			window.location.href = language
		}
	}
	if (to.meta.title) {
		// console.log(to.meta.title)
		document.title = to.meta.title
	}
	next()
})

export default router
